import { MenuITemAction } from './menu-item-action';

export class MenuItemEvent<T> {
    context: T;
    action: MenuITemAction;
}
